// extracted by mini-css-extract-plugin
export var emptyState = "_74-d";
export var statCard = "_74-c";
export var table = "_74-0";
export var tableCell = "_74-4";
export var tableCellClickable = "_74-5 _74-4";
export var tableCellDefault = "_74-6 _74-4";
export var tableCellEmpty = "_74-8";
export var tableCellWithValue = "_74-7";
export var tableContainer = "_74-e";
export var tableHeaderWeight = "_74-1";
export var tableHeaderZone = "_74-2";
export var tableRowHeader = "_74-3";
export var viewModeButton = "_74-9";
export var viewModeButtonActive = "_74-a _74-9";
export var viewModeButtonInactive = "_74-b _74-9";